import { useQueryClient } from '@tanstack/react-query';
import {
	isResponseStatus,
	lastDocumentsQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import { first, is } from '@gov-nx/core/types';
import type { ServiceCode } from '@gov-nx/module/service';
import { useDocumentsDownload } from './useDocumentDownload';
import { useDocumentFirstFile } from './useDocumentFirstFile';

export const useLastDocument = (
	code: ServiceCode,
	enabled: boolean,
	payload:
		| {
				typOsoby: 'PO';
				poZahranicni: boolean;
		  }
		| { typOsoby: 'FO' }
) => {
	const { prepare } = useDocumentsDownload();
	const queryClient = useQueryClient();
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery(
		{
			queryKey: [code, payload],
			queryFn: async () =>
				lastDocumentsQuery(axiosInstance)({
					...payload,
					kodPodani: 'REJSTRIK_TRESTU_VYPIS_EGSB_2',
				}),
			enabled,
			retry: false,
			refetchOnWindowFocus: false,
		},
		{ errorIgnoreFilter: isResponseStatus(404) }
	);

	const lastDocumentId = first(
		query.data?.data.dokumenty
			?.map((document) => document.dokumentId)
			.filter(is) ?? []
	);

	const souborId = useDocumentFirstFile(lastDocumentId);

	return {
		lastDocument:
			lastDocumentId && souborId
				? prepare({
						documentId: lastDocumentId,
						souborId: souborId,
					})
				: undefined,
		data: query.data?.data,
		invalidateCache: async () => {
			await queryClient.invalidateQueries({ queryKey: [code, payload] });
		},
	};
};
